import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useEventReporter } from '~/event-reporter/EventReporter';
import { useUnregisterMobileNotification } from '~/hooks/useUnregisterMobileNotification';
export const useUserInitiatedLogout = ()=>{
    const { reset } = useStoreActions();
    const { getState } = useStoreStatic();
    const { native } = useIoContext();
    const { sendEventToGtm } = useEventReporter();
    const { unregisterMobileNotification } = useUnregisterMobileNotification();
    async function logOutUser() {
        sendEventToGtm('logout', {});
        const { nativePushTokenInfo, authToken } = getState();
        if (nativePushTokenInfo != null) {
            const { token, platform } = nativePushTokenInfo;
            unregisterMobileNotification({
                token,
                platform,
                authToken
            });
        }
        await native.session.setJustLoggedOut();
        reset(true);
    }
    return {
        logOutUser
    };
};
